export const baseColor = "#1b2047";

export const highlightColor = "#040721";

